module.exports = __webpack_public_path__ + "img/market.a6d3165c.jpg";